import "../../../styles/input.scss";

import Icon, {iconTypes} from "./Icon.jsx";
import React, {Component} from "react";
import {getPropertyValue, makePropertyValue} from "../util/changeUtils.jsx";

import PropTypes from "prop-types";

export default class TextField extends Component {
    constructor(props){
        super(props);

        this.state = {
            focused: false,
            property: props.property,
            source: props.source,
            value: getPropertyValue(props.source, props.property)
        };
        
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onSetValue = this.onSetValue.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getClassName = this.getClassName.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (state.source !== props.source) {
            return {
                source: props.source,
                value: getPropertyValue(props.source, props.property)
            };
        }

        return null;
    }

    onClick(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    onChange(event) {
        this.setState({
            value: event.target.value === "" ? undefined : event.target.value
        });
        if (this.props.onChange){
            this.props.onChange(makePropertyValue(this.props.property, event.target.value), this.props.source);
        }
        if(this.props.usingSubmit){
            this.onSetValue(event.target.value === "" ? undefined : event.target.value);
        }
    }
    onFocus() {
        this.setState({ focused: true });
    }
    onBlur() {
        this.setState({ focused: false });
        //
        this.onSetValue(this.state.value);
    }
    onSetValue(value) {
        const {
            onEdit,
            source,
            property,
        } = this.props;
        const currentValue = getPropertyValue(source, property);
        if(value !== currentValue) {
            onEdit(makePropertyValue(property, value), source);
        }
    }
    onKeyUp(target) {
        if( this.props.capsLockStatusCallback ){
            this.props.capsLockStatusCallback( target.getModifierState("CapsLock") );
        }
        if(target.key === "Enter") {
            this.onBlur();
        }
    }
    getClassName() {
        const {
            iconType,
            validation,
            invisibleBackground,
            price,
        } = this.props;

        let className = `invisible-bg  ${(this.props.smallText === true ?  (this.props.darkBorder === true ? "input-text-small-dark-border" : "input-text-small") : "input-text")}`; 
        if(iconType){
            className += " icon";
        }
        className += invisibleBackground?" invisible-bg":" text-field-bg";
        if(!this.state.focused){
            if(validation==null || validation(this.state.value)===true){
                className += " is-valid";
            }
        }
        if(price){
            className += " price";
        }  
        return className;
    }

    render() {
        const {
            className,
            disabled,
            locked,
            iconType,
            iconColor,
            validation,
            spellcheck,
            type,
            placeholder,
            tabIndex,
            maxLength,
            autoComplete,
            autoFocus,
            min,
        } = this.props;

        const isValid = validation==null || validation(this.state.value);
        
        return (
            <React.Fragment>
                <div className={className?className:"input-container"} onClick={this.onClick}>
                    <input
                        className={this.getClassName()}
                        type={type}
                        onChange={this.onChange}
                        onKeyUp={this.onKeyUp}
                        disabled={disabled || locked}
                        value={this.state.value || ""}
                        onFocus={this.onFocus}
                        onBlur={this.onBlur}
                        spellCheck={spellcheck==null?false:spellcheck}
                        placeholder={placeholder}
                        tabIndex={tabIndex}
                        maxLength={maxLength}
                        autoComplete={autoComplete}
                        autoFocus={autoFocus}
                        min={min}

                    />
                    {iconType && (
                        <Icon type={iconType} color={iconColor} className="input-text-icon" opacity={isValid?undefined:0.4}/>
                    )}
                    {locked && (
                        <Icon type={iconTypes.lock} className="input-text-lock-icon"/>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

TextField.propTypes = {
    //
    // Mandatory
    //
    // called when finished editing input field
    onEdit: PropTypes.func.isRequired,
    property: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ])
        )
    ]).isRequired,
    source: PropTypes.object.isRequired,
    //
    // Optional
    //
    // maximum length of input date
    maxLength: PropTypes.number,
    // called every time the field changes
    onChange: PropTypes.func,
    // disabling inputs
    disabled: PropTypes.bool,
    // a lock will apear on the right side
    locked: PropTypes.bool,
    // what iconType should be visilbe on the left side
    iconType: PropTypes.string,
    // what color the icon should have
    iconColor: PropTypes.string,
    // function to validate the value of the field
    validation: PropTypes.func,
    // enable/disable browers support for spellchecking
    spellcheck: PropTypes.bool,
    // what type of input default "text", other options "number", "password"
    type: PropTypes.string,
    // visible ghost text when no value is entered
    placeholder: PropTypes.string,
    // manualy setting tabIndex
    tabIndex: PropTypes.number,
    // if using form and callbacks for onEdit is not wanted
    usingSubmit: PropTypes.bool,
    // scss style
    className: PropTypes.string,
    // for disabling autocomplete useful for password fields
    autoComplete: PropTypes.string,
    // if the background should be invisible
    invisibleBackground: PropTypes.bool,
    // if the text should be in smaller font
    smallText: PropTypes.bool,
    // Callback if caps lock is down
    capsLockStatusCallback: PropTypes.func,
    // Sets autofocus
    autoFocus: PropTypes.bool,
    // if the underlying border should be dark
    darkBorder: PropTypes.bool,
    // minimum value of numeric field
    min: PropTypes.number,
    // for prices with text that are right aligned
    price: PropTypes.bool,
};

TextField.defaultProps = {
    locked: false,
    disabled: false,
    validation: null,
    usingIcon: undefined,
    type: "text",
    usingSubmit: false,
    invisibleBackground: false,
    autoFocus: false,
};